import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { AuthContext } from "../Infrastructure/provider/AuthProvider";
import { publicationAPI } from "../Redux/services/PublicationService";
import {useNavigate, useParams} from "react-router-dom";

const CreatePost = () => {
    const { id } = useParams();
    const { user } = useContext(AuthContext);

    const { data, isLoading } = publicationAPI.useFetchPublicationQuery(id);
    const [updatePost] = publicationAPI.useUpdatePublicationMutation();
    console.log(data)
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            category: "",
            title: "",
            content: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset({
                category: data.publication.category.id?.toString() || "",
                title: data.publication.title || "",
                content: data.publication.content || "",
            });
        }
    }, [data, reset]);

    const putPost = (data: any) => {
        console.log(data.content)
        const body = {title: data.title, content: String(data.content), category_id: Number(data.category)};
        updatePost({id, body})
        navigate('/category')
    };

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-[75vh] text-gray-600">
                Завантаження публікації...
            </div>
        );
    }

    return (
        <div className="flex flex-col h-[75vh] overflow-y-auto">
            <form
                onSubmit={handleSubmit(putPost)}
                className="bg-white border border-gray-300 rounded-md shadow-sm p-4 flex flex-col gap-4 flex-1"
            >
                {/* Категория */}
                <div className="flex flex-col">
                    <div className="flex items-center gap-3">
                        <label
                            htmlFor="category"
                            className="text-blue-800 font-medium w-32 text-right"
                        >
                            Категорiя:
                        </label>
                        <select
                            id="category"
                            {...register("category", { required: "Оберiть категорiю" })}
                            className={`border rounded-sm px-3 py-2 w-60 text-blue-800 focus:outline-none focus:ring-2 ${
                                errors.category
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-blue-300"
                            }`}
                        >
                            <option value="">-- Оберiть категорiю --</option>
                            {user.accessible_categories.map((item: any) => (
                                <option key={item.id} value={item.id}>
                                    {item.title}
                                </option>
                            ))}
                        </select>
                    </div>
                    {errors.category && (
                        <p className="text-red-500 text-xs ml-[8.2rem] mt-1">
                            {errors.category.message as string}
                        </p>
                    )}
                </div>

                {/* Заголовок */}
                <div className="flex flex-col">
                    <div className="flex items-center gap-3">
                        <label
                            htmlFor="title"
                            className="text-blue-800 font-medium w-32 text-right"
                        >
                            Заголовок:
                        </label>
                        <input
                            id="title"
                            type="text"
                            {...register("title", { required: "Введите заголовок" })}
                            placeholder="Enter publication title..."
                            className={`border rounded-sm px-3 py-2 w-full text-blue-800 focus:outline-none focus:ring-2 ${
                                errors.title
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-blue-300"
                            }`}
                        />
                    </div>
                    {errors.title && (
                        <p className="text-red-500 text-xs ml-[8.2rem] mt-1">
                            {errors.title.message as string}
                        </p>
                    )}
                </div>

                {/* Контент */}
                <div className="flex flex-col flex-1">
                    <textarea
                        id="content"
                        {...register("content", { required: "Введите текст публикации" })}
                        placeholder="Enter publication text..."
                        className={`border rounded-md p-3 w-full h-[60vh] resize-none text-blue-800 focus:outline-none focus:ring-2 ${
                            errors.content
                                ? "border-red-500 focus:ring-red-300"
                                : "border-gray-300 focus:ring-blue-300"
                        }`}
                    />
                    {errors.content && (
                        <p className="text-red-500 text-xs mt-1">
                            {errors.content.message as string}
                        </p>
                    )}
                </div>

                {/* Кнопка */}
                <div className="flex justify-start mt-3">
                    <button
                        type="submit"
                        className="bg-[#4573c4] text-white px-6 py-1 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                    >
                        Зберегти
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreatePost;
